import { buildAction } from 'store/actions/actionCreator'

import { FETCH_STORE } from './constants'

export const fetchStore = buildAction(FETCH_STORE, 'payload')
